import { Element } from "@craftjs/core";
import { useToken } from "@gluestack-style/react";
import { Box, HStack } from "components/ui";
import { ShieldCheck } from "lucide-react-native";
import React from "react";
import { useIsMobile } from "utils/hooks/useIsMobile";

export const FeaturesPanelContent = ({ minHeight = 320, ...props }) => {
	const isMobile = useIsMobile();
	const resolvedPrimarylight = useToken("colors", "primarylight");
	const cardStyle = {
		// backgroundColor: "#fff",
		// borderWidth: 1,
		// borderColor: "#e0e0e0",
		// borderRadius: 8,
		// padding: 24,
		// minHeight,
		// flex: 1,
		// flexDirection: "column" as const,
		// justifyContent: "flex-start" as const,
		// textAlign: "center",
		display: "flex",
		flexDirection: "column",
		gap: 8,
		flex: 1,
		maxWidth: 246,
	};

	if (isMobile) {
		return (
			<Box style={cardStyle} mb={16}>
				<HStack gap={6}>
					<ShieldCheck color={resolvedPrimarylight} size={48} />
					<Box style={{ flex: 1, gap: 4 }}>{props.children}</Box>
				</HStack>
			</Box>
		);
	}
	return (
		<Box style={cardStyle} mb={0}>
			<div style={{ display: "flex", paddingBlock: 12, flexDirection: "column" }}>
				<ShieldCheck color={resolvedPrimarylight} size={48} />
			</div>
			{props.children}
		</Box>
	);
};

export const PageFeaturesPanel = () => {
	const isMobile = useIsMobile();

	if (isMobile) {
		return (
			<Box>
				<Element is={FeaturesPanelContent} id="features-panel-content" data-cy="features-panel-content" minHeight={320}></Element>
			</Box>
		);
	}
	return (
		<div
			style={{
				width: "100%",
				marginBottom: 16,
				flex: "0 1 calc(25% - 8px)",
				display: "flex",
				flexDirection: "column",
				alignItems: "stretch",
			}}
		>
			<Element is={FeaturesPanelContent} id="features-panel-content" data-cy="features-panel-content" minHeight={320}></Element>
		</div>
	);
};
